import React from "react";
import { PiEye } from "react-icons/pi";
import { useLocation } from "react-router-dom";

// Helper function to check if DisplayAsClient mode is enabled
export const isDisplayAsClientEnabled = () => {
  return sessionStorage.getItem("DisplayAsClient") === "true";
};

export const UserIsSpecial = (user, check_always = false) => {
  if (isDisplayAsClientEnabled() && !check_always) {
    return false;
  }
  return user?.is_admin || user?.is_superuser || user?.is_worker;
};

export const UserSpecialHasLimits = (user) => {
  if (user?.is_admin) {
    return false;
  }

  if (!user?.payment_date) {
    return true;
  }

  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const paymentDate = new Date(user.payment_date);

  return paymentDate < today;
};

export const UserIsAdmin = (user) => {
  if (isDisplayAsClientEnabled()) {
    return false;
  }
  return user?.is_admin;
};

export const UserAdminOrArchitect = (user) => {
  if (isDisplayAsClientEnabled()) {
    return false;
  }
  return user?.is_admin || user?.is_superuser;
};

export const UserIsNotClient = (user) => {
  if (isDisplayAsClientEnabled()) {
    return false;
  }
  return (
    user?.is_admin ||
    user?.is_superuser ||
    user?.is_worker ||
    user?.is_specialist
  );
};

export const UserIsNotSpecialist = (user) => {
  return !user?.is_specialist;
};

export const ProjectAccessSurvey = (is_survey_active, user) => {
  return UserIsNotClient(user) || is_survey_active;
};

// Toggle button component for DisplayAsClient mode
export const DisplayAsClientToggle = ({ user }) => {
  const location = useLocation();
  const [isEnabled, setIsEnabled] = React.useState(
    sessionStorage.getItem("DisplayAsClient") === "true",
  );

  React.useEffect(() => {
    const pathname = location.pathname;
    const restrictedPaths = ["/admin", "/panel", "/sprzedawca"];
    const isRestricted = restrictedPaths.some((path) =>
      pathname.startsWith(path),
    );

    if (isRestricted && isEnabled) {
      sessionStorage.setItem("DisplayAsClient", "false");
      setIsEnabled(false);
    }
  }, [location.pathname, isEnabled]);

  const handleToggle = () => {
    const newValue = !isEnabled;
    sessionStorage.setItem("DisplayAsClient", newValue.toString());
    setIsEnabled(newValue);
    // // Reload the page to apply the new permission settings
    window.location.reload();
  };

  // Only show toggle for admin or superuser
  if (
    (!user?.is_admin && !user?.is_superuser && !user?.is_worker) ||
    location.pathname.endsWith("/komunikator")
  ) {
    return null;
  }

  return (
    <button
      onClick={handleToggle}
      id={isEnabled ? "active" : ""}
      className="outlineGrey buttonWithIcon circleButton"
      title={isEnabled ? "Wyłącz podgląd klienta" : "Wyświetl jako klient"}
    >
      <PiEye />
    </button>
  );
};
